export default __webpack_public_path__ + "static/media/1829.377ba62d.png";